import React from 'react'
import { Stack } from '@mui/material'

import RichText from '@/src/components/common/RichText'

interface HolidayParagraphsProps {
    paragraphs: string[]
    isMobile: boolean
}

const HolidayParagraphs: React.FC<HolidayParagraphsProps> = ({ paragraphs, isMobile }) => {
    return (
        <Stack spacing={1.5}>
            {paragraphs.map(paragraph => (
                <RichText
                    key={paragraph}
                    html={paragraph}
                    sx={{
                        m: 0,
                        fontSize: isMobile ? '0.875rem' : '0.938rem',
                        lineHeight: 1.75,
                        color: 'textColors.secondary'
                    }}
                />
            ))}
        </Stack>
    )
}

export { HolidayParagraphs }
export type { HolidayParagraphsProps }
export default HolidayParagraphs
